import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { messageIcon, messageType } from '../message-type';

@Component({selector:'app-user-message', standalone:true, imports:[CommonModule], templateUrl:'./user-message.component.html', styleUrls:['./user-message.component.scss']})
export class UserMessageComponent implements OnChanges {
  @Input() type = 'info';
  @Input() title = '';
  @Input() message = '';
  @Input() actionLabel = '';
  @Input() actionColor = 'primary';
  @Input({transform:booleanAttribute}) dismissible = true;
  @Input({transform:booleanAttribute}) busy = false;
  @Output() close = new EventEmitter<void>();
  @Output() action = new EventEmitter<void>();
  hidden = false;
  constructor(public globalService: GlobalService) {}
  get severity() { return messageType(this.type); }
  get icon() { return messageIcon(this.severity); }
  get heading() {
    if (this.title) return this.title;
    const english = {error:'Action needed',warning:'Please review',confirmation:'Please confirm',info:'Good to know',success:'Completed'};
    const arabic = {error:'يلزم اتخاذ إجراء',warning:'يرجى المراجعة',confirmation:'يرجى التأكيد',info:'معلومة',success:'تم بنجاح'};
    return (this.globalService.isRTL ? arabic : english)[this.severity];
  }
  ngOnChanges() { this.hidden = false; }
  dismiss() { if (this.busy) return; this.hidden = true; this.close.emit(); }
}
